(function ($) {
    $(document).ready(function () {
        $(".languages-dropdown .languages").css("display", "none");

        $(".languages-dropdown .js-dropdown-btn").on("click", function () {
            if ($(".languages-dropdown .languages").hasClass("visible")) {
                $(".languages-dropdown .languages").removeClass("visible");
                $(".languages-dropdown .languages").slideUp(300);
            } else  {
                $(".languages-dropdown .languages").addClass("visible");
                $(".languages-dropdown .languages").slideDown(300);
            }
        });

        $(".languages-dropdown .languages .lang-link").on("click", function () {
            $(".languages-dropdown .languages").removeClass("visible");
            $(".languages-dropdown .languages").slideUp(300);
        });

    });
})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/add_voice.es6